/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:42:47 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-12-05 21:22:09
 */
import animationMixin from '@/mixins/animation.js';

export default {
  mixins: [animationMixin],
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    this.runAnimations();
  },
  watch: {
    currentPage: function (page) {
      if (page === this.index) {
        this.runAnimations();
      }
    }
  },
  render (h) {
    return (
      <div style={ this.element.getStyle({ position: 'absolute', isRem: false })}>
        {this.$slots.default}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/module/album/engine/node-wrapper.js